import { mapByID, mapCreate, mapDestroy, mapList, mapUpdate } from '@/services/wallMaps.service'

export default {
	namespaced: true,
	state: {
		// SERVICE MAP
		mapList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		map: {},

		// STATUS SERVICE MAP
		mapStatus: 'pending',
		mapSaveStatus: 'init',
		mapDeleteStatus: 'init',
	},
	getters: {
		// SERVICE MAP
		getMapList(state) {
			return state.mapList
		},
		getMap(state) {
			return state.map
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE MAP
		getMapDeleteStatus(state) {
			return state.mapDeleteStatus
		},
		getMapSaveStatus(state) {
			return state.mapSaveStatus
		},
		getMapStatus(state) {
			return state.mapStatus
		},
	},
	mutations: {
		// SERVICE MAP
		MAP_LIST(state, value) {
			state.mapList = value
		},
		SET_MAP(state, value) {
			state.map = value
		},

		// STATUS SERVICE MAP
		MAP_STATUS(state, value) {
			state.mapStatus = value
		},
		MAP_SAVE_STATUS(state, value) {
			state.mapSaveStatus = value
		},
		MAP_DELETE_STATUS(state, value) {
			state.mapDeleteStatus = value
		},
	},
	actions: {
		// Service Map
		async fetchMapList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('MAP_STATUS', 'pending')
			commit('MAP_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await mapList(params)
				commit('MAP_STATUS', 'init')
				commit('MAP_LIST', data)
				return data
			} catch (error) {
				commit('MAP_STATUS', 'init')
				throw error
			}
		},
		async fetchMapByID({ commit }, params) {
			commit('MAP_STATUS', 'pending')
			try {
				const { data } = await mapByID(params)
				commit('MAP_STATUS', 'init')
				commit('SET_MAP', data.data)
				return data
			} catch (error) {
				commit('MAP_STATUS', 'init')

				return error
			}
		},
		async saveNewMap({ commit }, params) {
			commit('MAP_SAVE_STATUS', 'pending')
			try {
				const { data } = await mapCreate(params)
				commit('MAP_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAP_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateMap({ commit }, params) {
			commit('MAP_SAVE_STATUS', 'pending')
			try {
				const { data } = await mapUpdate(params)
				commit('MAP_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAP_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteMapByID({ commit }, params) {
			commit('MAP_DELETE_STATUS', 'pending')
			try {
				const { data } = await mapDestroy(params)
				commit('MAP_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAP_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
